<div class="d-flex align-items-start g-g">
  <form class="w-50 d-flex align-items-center g-g" (ngSubmit)="addTddOption()">
    <div class="form tdd-subsection flex-fill">
      <button
        (click)="switchTddType()"
        type="button"
        class="form-control d-flex justify-content-between align-items-center"
      >
        <span
          >{{ tddSlots.length == 5 ? "Low Latency" : "Normal" }} -
          {{ tddSlots.length }} slots</span
        >
        <i class="fa-solid fa-repeat"></i>
      </button>
      <div class="tdd-slot-option align-self-center">
        <ul class="d-flex align-items-center tdd-slot-list">
          @for (slot of tddSlots; track slot; let i = $index) {
            <li class="tdd-slot tdd-slot-{{ slot.toLowerCase() }}">
              <button
                type="button"
                class="tdd-slot tdd-slot-{{
                  slot.toLowerCase()
                }} tdd-slot-button"
                (click)="loopSlot(i)"
              >
                {{ slot }}
              </button>
            </li>
          }
        </ul>
      </div>
    </div>
    <button type="submit" class="btn btn-success">
      <i class="fa-solid fa-circle-plus"></i>
      <i class="fa-solid fa-caret-right"></i>
    </button>
  </form>

  <ul
    class="flex-fill d-flex flex-column g-g tdd-subsection align-self-stretch"
  >
    @for (tddOption of defaultTddOptions; track tddOption; let i = $index) {
      <li
        class="d-flex align-items-center g-g justify-content-between tdd-option default"
      >
        <div class="d-flex align-items-center g-g">
          <oaibox-tdd-option [tddConfigOption]="tddOption"></oaibox-tdd-option>
          <span class="tdd-type">
            Period
            <span class="tdd-config-property-value">{{
              tddOption.length == 5 ? "2.5ms" : "5ms"
            }}</span>
          </span>
        </div>
        <span>default</span>
      </li>
    }
    @for (tddOption of editableTddOptions; track tddOption; let i = $index) {
      <li
        class="d-flex align-items-center g-g justify-content-between tdd-option"
      >
        <div class="d-flex align-items-center g-g">
          <oaibox-tdd-option [tddConfigOption]="tddOption"></oaibox-tdd-option>
          <span class="tdd-type">
            Period
            <span class="tdd-config-property-value">{{
              tddOption.length == 5 ? "2.5ms" : "5ms"
            }}</span>
          </span>
        </div>
        <button (click)="removeTddOption(i)" class="remove-button">
          <i class="fa-solid fa-trash"></i>
        </button>
      </li>
    }
  </ul>
</div>
